export default "__VITE_ASSET__1cEP_8_w__"